export default __webpack_public_path__ + "static/media/login_2.daa86baf.png";